import Image, { StaticImageData } from 'next/image';
import { memo } from 'react';
import styles from './styles.module.scss';

interface IManagersWalletAndRewardsFeatureProps {
  title: string;
  bullets: string[];
  image: StaticImageData;
}

const ManagersWalletAndRewardsFeature = memo<IManagersWalletAndRewardsFeatureProps>(
  ({ title, bullets, image }) => (
    <div className={styles.container}>
      <div className={styles.details}>
        <h2 className={styles.detailsTitle}>{title}</h2>
        <ul className={styles.detailsList}>
          {bullets.map((bullet: string) => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
      </div>

      <Image src={image} alt="" className={styles.image} priority={false} />
    </div>
  ),
);

ManagersWalletAndRewardsFeature.displayName = 'ManagersWalletAndRewardsFeature';

export default ManagersWalletAndRewardsFeature;
